module.exports = __webpack_public_path__ + "static/media/valor1.75b800d7.png";